var styles = {
  "tooltip": "_tooltip_wyzomh_4",
  "closing": "_closing_wyzomh_8",
  "content": "_content_wyzomh_12",
  "rs-reset-letter-spacing": "_rs-reset-letter-spacing_wyzomh_1",
  "initial": "_initial_wyzomh_47",
  "trigger": "_trigger_wyzomh_81"
};
export { styles as default };
